import { Collection } from "@mcleod/core";
import { ComponentConstructor, PanelProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./examples/AbstractComponentDemoExamples";
import { AbstractSectionPanel } from "./AbstractSectionPanel";
import { AddlExampleLineHeaderPanel as AddlExampleLineHeaderPanel } from "./AddlExampleLineHeaderPanel";
import { AddlExampleLinePanel } from "./AddlExampleLinePanel";

export class AddlExampleSectionPanel extends AbstractSectionPanel {
    constructor(title: string, propDefs: Collection<any>, examples: AbstractComponentDemoExamples,
        componentClassRef: ComponentConstructor, componentName: string, props?: Partial<PanelProps>) {
        super(title, propDefs, examples, componentClassRef, componentName, props);
    }

    protected override getLineHeaderPanelClass(): ComponentConstructor {
        return AddlExampleLineHeaderPanel;
    }
    protected override getLinePanelClass(): ComponentConstructor {
        return AddlExampleLinePanel;
    }
}
